import { BaseApi } from './base.api.js';

export class GapApi extends BaseApi {
    constructor(client) {
        super(client, '/gap');
    }
}
